<template>
  <div id="user-rights">
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <el-form
            ref="formselect"
            :model="formselect"
            label-width="150px"
            @submit.native.prevent
            class="queryform_div"
        >
        <el-row :gutter="24">
          <el-col :span="6">
          <el-form-item :label="$t('UserName') + '/'+ $t('DisplayName') + '/' + $t('Email')">
            <el-input
                @keyup.enter.native="getUserList"
                class="queryform"
                v-model="formselect.queryString"
            ></el-input>
          </el-form-item>
          </el-col>
          <el-col :span="7">

          <el-form-item :label="$t('RoleName')">
            <!-- <el-input
                @keyup.enter.native="getUserList"
                class="queryform"
                v-model="formselect.roleName"
            ></el-input> -->
            <el-select
                  v-model="formselect.roleId"
                  style="width: 100%"
                  filterable
                  clearable
                  :placeholder="$t('el.select.placeholder')"
              >
                <el-option
                    :label="v.displayName"
                    :value="v.id"
                    :key="v.id"
                    v-for="v of roleDic"
                ></el-option>
              </el-select>
          </el-form-item>
          </el-col>
        </el-row>
      <el-row :gutter="24">
        
          <el-col :span="12">
          <el-form-item>
            <el-button @click="getUserList" type="primary">{{ $t('Query') }}</el-button>
            <el-button @click="reset">{{ $t('Reset') }}</el-button>
          </el-form-item>
        </el-col>
          </el-row>
        </el-form>
        <template>
          <el-button
              type="primary"
              icon="el-icon-circle-plus-outline"
              @click="add"
              v-if="judge('User_Create')"
              style="margin-bottom: 10px"
          >{{ $t('Add') }}
          </el-button>
          <el-table
              :data="userInfoList"
              border
              v-loading="loading"
              style="width: 100%"
          >
            <!--                        <el-table-column prop="id"-->
            <!--                                         label="用户编号"-->
            <!--                                         min-width="10%">-->
            <!--                        </el-table-column>-->
            <el-table-column prop="userName" :label="$t('Account')" min-width="15%">
            </el-table-column>
            <el-table-column prop="name" :label="$t('UserName')" min-width="15%">
            </el-table-column>
            <el-table-column prop="roleNames" :label="$t('RoleName')" min-width="12%">
            </el-table-column>
            <el-table-column prop="UserDept" :label="$t('Department')" min-width="15%">
            </el-table-column>
            <el-table-column
                prop="emailAddress"
                :label="$t('EmailAddress')"
                min-width="26%"
            >
            </el-table-column>
            <el-table-column
                prop="mobilePhone"
                :label="$t('Contact Phone')"
                min-width="15%"
            >
            </el-table-column>
            <el-table-column
                prop="languageName"
                :label="$t('DefaultLanguage')"
                min-width="15%"
            >
              <template #default="scope">
                <el-tag v-if="scope.row.languageName" :type="scope.row.languageName == 'en' ? '':'danger'">{{ scope.row.languageName == 'zh-Hans' ? '中文':'English' }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column
                prop="sendEmailStatus"
                :label="$t('SendEmailEnable')"
                min-width="15%"
            >
              <template #default="scope">
                <el-tag v-if="scope.row.sendEmailStatus" :type="scope.row.sendEmailStatus? '':'danger'">{{ scope.row.sendEmailStatus ? $t('yes'):$t('No') }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column :label="$t('Action')" min-width="28%">
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="primary"
                    v-if="judge('User_Update')"
                    @click="editInfo(scope.row)"
                >{{ $t('Edit') }}
                </el-button>

                <template v-if="judge('User_Delete')">
                  <el-popconfirm
                      placement="top"
                      :confirmButtonText="$t('Delete')"
                      :cancelButtonText="$t('Cancel')"
                      icon="el-icon-info"
                      iconColor="red"
                      @onConfirm="deleteEleById(scope.row.id)"
                      :title="$t('DeleteConfirm')"
                  >
                    <el-button
                        size="mini"
                        type="danger"
                        slot="reference"
                        style="margin-left: 10px"
                    >{{ $t('Delete') }}
                    </el-button>
                  </el-popconfirm>
                </template>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
              background
              :page-size="6"
              @current-change="handleCurrentChange"
              layout="prev, pager, next"
              :total="pagination.totalPage"
          >
          </el-pagination>
        </template>
      </el-main>
    </el-scrollbar>
    <el-dialog
        :title="title"
        v-if="dialogAddUser"
        :visible.sync="dialogAddUser"
        width="900px"
        top="10vh"
    >
      <el-form
          ref="userform"
          :model="userform"
          label-width="120px"
          :inline="true"
      >
        <el-row :gutter="24">
          <!--                    <el-col :span="12">-->
          <!--                        <el-form-item label="用户编号">-->
          <!--                            <el-input v-model="userform.id" :disabled="true" placeholder="创建完成后自动生成"-->
          <!--                                      style="width:280px"></el-input>-->
          <!--                        </el-form-item>-->
          <!--                    </el-col>-->
          <el-col :span="12">
            <el-form-item
                :label="$t('Account')"
                prop="userName"
                :rules="[{ required: true, message: $t('EnterAccount') }]"
            >
              <el-input
                  autocomplete="off"
                  :disabled="title == $t('EditInfo')"
                  v-model="userform.userName"
                  style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                :label="$t('Password')"
                v-if="title == $t('AddUser')"
                prop="password"
                :rules="[{ required: true, message: $t('EnterPassword')}]"
            >
              <el-input
                  :type="pwd ? 'text' : 'password'"
                  v-model="userform.password"
                  :show-password="true"
                  :disabled="true"
                  style="width: 280px"
              ></el-input>
            </el-form-item>
            <el-form-item :label="$t('Password')" v-else prop="password">
              <el-input
                  type="password"
                  style="position: fixed; bottom: -9999px"
              ></el-input>
              <el-input
                  :placeholder="$t('EnterPasswordChange')"
                  v-model="userform.password"
                  show-password
                  style="width: 280px"
              ></el-input>
              <!--                            <el-input-->
              <!--                                    :type="pwd ? 'text' : 'password'"-->
              <!--                                    placeholder="请输入新密码，默认为空则不修改"-->
              <!--                                    v-model="userform.password"-->
              <!--                                    style="width: 280px"-->
              <!--                            ></el-input>-->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                :label="$t('UserName')"
                prop="name"
                :rules="[{ required: true, message:  $t('EnterUserName') }]"
            >
              <el-input
                  autocomplete="off"
                  v-model="userform.name"
                  style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                :label="$t('EmailAddress')"
                prop="emailAddress"
                :rules="[{ required: true, message:  $t('EnterEmailAddress')}]"
            >
              <el-input
                  v-model="userform.emailAddress"
                  style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
                :label="$t('Contact Phone')"
                prop="mobilePhone"
                :rules="[{ required: true, message:  $t('EnterPhoneNumber')}]"
            >
              <el-input
                  maxLength="11"
                  v-model="userform.mobilePhone"
                  style="width: 280px"
              ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
            :label="$t('DefaultLanguage')"
            >
            <el-select
                    :placeholder="$t('el.select.placeholder')"
                    v-model="userform.languageName">
                  <el-option value="zh-Hans" label="简体中文"></el-option>
                  <el-option value="en" label="English"></el-option>

                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
            :label="$t('SendEmailEnable')"
            >
            <el-select
                    :placeholder="$t('el.select.placeholder')"
                    v-model="userform.sendEmailStatus">
                    <el-option :value=true :label="$t('yes')"></el-option>
                        <el-option :value=false :label="$t('No')"></el-option>

                </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$t('RoleAndData')">
              <el-table
                  :data="RoleTable"
                  ref="RoleTable"
                  border
                  style="width: 722px"
              >
                <el-table-column :label="$t('Action')" width="65%">
                  <template slot-scope="scope">
                    <el-button
                        icon="el-icon-delete"
                        circle
                        size="mini"
                        type="danger"
                        @click="delBuildRow(scope.$index, scope.row)"
                    ></el-button>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('SelectRole')" min-width="35%">
                  <template slot-scope="scope">
                    <el-select
                        v-model="scope.row.id"
                        :placeholder="$t('el.select.placeholder')"
                        @change="selectChange(scope.row)"
                    >
                      <el-option
                          v-for="(item, index) in RoleList"
                          :key="index"
                          :label="item.name"
                          :value="item.id"
                      >{{ item.name }}
                      </el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('DataPermissionAllocation')" min-width="65%">
                  <template slot-scope="scope">
                    <el-cascader
                        v-if="scope.row.roles == 'All'"
                        v-model="scope.row.access"
                        :focus="getfocus(scope.row.access)"
                        :options="optionsinfo"
                        :key="scope.$index"
                        :props="props"
                        clearable
                        class="cascaderInput"
                        style="width: 100%;"
                    >
                    </el-cascader>
                    <el-cascader
                        v-else-if="scope.row.roles == 'Factory'"
                        v-model="scope.row.access"
                        :focus="getfocus(scope.row.access)"
                        :options="optionsFac"
                        :props="props"
                        clearable
                        class="cascaderInput"
                        style="width: 100%;"
                    >
                    </el-cascader>
                    <el-cascader
                        v-else-if="scope.row.roles == 'Laboratory'"
                        v-model="scope.row.access"
                        :focus="getfocus(scope.row.access)"
                        :options="optionsLab"
                        :props="props"
                        clearable
                        class="cascaderInput"
                        style="width: 100%;"
                    >
                    </el-cascader>
                    <el-cascader
                        v-else-if="scope.row.roles == 'Device'"
                        v-model="scope.row.access"
                        :options="optionsAll"
                        :focus="getfocus(scope.row.access)"
                        :props="props"
                        clearable
                        class="cascaderInput"
                        style="width: 100%;"
                    >
                    </el-cascader>
                  </template>
                </el-table-column>
              </el-table>
              <el-button
                  class="el-icon-plus"
                  @click.prevent="addBuildRow()"
              ></el-button>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item style="margin-left: 120px">
              <el-button type="success" @click="onSubmit()">{{ $t('Confirm') }}</el-button>
              <el-button @click="dialogAddUser = false">{{ $t('Cancel') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>
    <el-dialog :title="$t('ConfirmPwd')" :visible.sync="dialogEditPwd">
      <el-form ref="pwdForm" v-model="pwdForm">
        <el-form-item :label="$t('AdminPwd')" label-width="100px">
          <el-input
              show-password
              :placeholder="$t('PleaseInputPwd')"
              v-model="pwdForm.pwd"
          ></el-input>
        </el-form-item>
        <el-form-item style="text-align: center">
          <el-button type="primary" @click="confirm">{{ $t('Confirm') }}</el-button>
          <el-button @click="dialogEditPwd = false">{{ $t('Cancel') }}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUser,
  UpdateUser,
  GetAllRegionChainList,
  GetUserRoleDatapermission,
  GetMyListDatapermission,
  ResetPassword,
  GetUserRoleListDatapermission,
  UpdateRoleDataPermissionList,
  addUser,
  deleteUser,
  getAllRole,
  getCityAlls,
  getFactoryAlls,
  GetBuildingAlls,
  getLabAlls,
  GetAllDevice,
  getAllRoleDic
} from "../../api/api";
import {mapState} from "vuex";
import {judgePermission} from "../../utils/util";

export default {
  name: "User_rights",
  data() {
    return {
      loading: false,
      pwd: true,
      arrMap: new Map(),
      dialogEditPwd: false,
      pwdForm: {pwd: ""},
      title: "",
      dialogAddUser: false,
      dialogEditUser: false,
      dialogEditPermission: false,
      isExtPwd: false,
      total: 0,
      userInfoList: [],
      citylist: [],
      factorylist: [],
      buildinglist: [],
      lablist: [],
      deviceList: [],
      allData: [],
      formselect: {
        queryString: "",
        roleId:"",
      },
      userform: {
        name: "",
        userName: "",
        password: "",
        dept: "",
        emailAddress: "",
        mobilePhone: "",
        languageName:"",
        isActive: true,
        sendEmailStatus:"",
      },
      props: {multiple: true},
      optionsinfo: [
        {
          value: "All",
          label: "All",
        },
      ],
      optionsAll: [],
      optionsCity: [],
      optionsFac: [],
      optionsBuild: [],
      optionsLab: [],
      RoleTable: [
        {
          id: "",
          roles: "",
          access: "",
          deviceCodes: [],
        },
      ],
      RoleTablerowNum: 1,
      arr: [],
      arr1: [],
      RoleList: [],
      pagination: {
        current: 1,
        pageSize: 6,
        totalPage: 0,
      },

      roleDic: {
        type: Array,
        // required: true,
        default: () => {
          return []
        }
      }
    };
  },
  async mounted() {
    this.getUserList();
    this.getRoleList();
    this.getcityList();
    this.getRoleDic();
  },
  watch: {
    dialogAddUser: {
      handler(value, old) {
        var that = this;
        setTimeout(function () {
          that.pwd = !value;

        }, 100);
        if (!value) {
          that.arrMap.clear()
        }
      },
      deep: true,
    },
  },
  methods: {
    getfocus(e) {

      var arr = [], arr1 = [], that = this
      if (e.length > 0) {
        setTimeout(function () {
          if (!document.getElementsByClassName("cascaderInput")[0]) return;
          var value = document.getElementsByClassName("cascaderInput")[0].lastChild.children
          for (var i = 0; i < value.length; i++) {
            arr.push(document.getElementsByClassName("cascaderInput")[0].lastChild.children[i].innerText)
          }
          e.map(i => {
            arr1.push(i[i.length - 1])
          })
          that.arrMap.forEach((value, key, map) => {
            // console.log(value,key,map)
            if (!arr1.includes(key)) {
              map.delete(key)
            }
          })
          // console.log(that.arrMap)
          e.map((j, index) => {
            //反转地域字符
            if (!that.arrMap.get(j[j.length - 1])) {
              if (arr.length == 0) return;
              arr[index] = arr[index].split("/").reverse().join("/")
              that.arrMap.set(j[j.length - 1], true)
            }
            //重写地域字符
            document.getElementsByClassName("cascaderInput")[0].lastChild.children[index].innerText = arr[index]
          })
        }, 500)
      } else {
        that.arrMap.clear()
      }
    },
    //随机生成密码
    makePassword(lenth) {
      var str = new Array();
      str[0] = "abcdefghijklmnopqrstuvwxyz";
      str[1] = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      str[2] = "0123456789";
      str[3] = "!~@#$%^&*()_+=-`,./<>?;':[]{}|";
      var result = "";
      var time0 = 0, time1 = 0, time2 = 0, time3 = 0;
      //  ;
      for (let index = 0; index < lenth; index++) {
        let strCount = Math.floor(Math.random() * str.length); //获取0-3的随机数
        var maxCount = lenth / str.length + 1;
        if (strCount == 0 && ++time0 > maxCount) strCount = 1;
        if (strCount == 1 && ++time1 > maxCount) strCount = 2;
        if (strCount == 2 && ++time2 > maxCount) strCount = 3;
        if (strCount == 3 && ++time3 > maxCount) strCount = Math.floor(Math.random() * str.length); //获取0-3的随机数
        var aaa = Math.floor(Math.random() * str[strCount].length);
        result += str[strCount][aaa];

      }
      return result;
    },
    judge(e) {//判断操作是否有权限
      return judgePermission(e);
    },
    reset() {//查询重置
      this.formselect.queryString = "";
      this.formselect.roleId = "";
      this.pagination.current =1; this.pagination.pageSize =6
      this.getUserList();
    },
    deleteEleById(id) {//删除用户
      var that = this;

      deleteUser(id).then((res) => {

        if (res.success) {
          that.$message.success(this.$t('deleteSuccessful'));
          that.getUserList();
        } else {
          that.$message.error(res.error.message);
        }
      });
    },
    add() {//创建用户
      this.userform = {
        userName: "",
        dept: "",
        emailAddress: "",
        mobilePhone: "",
        languageName:"",
        sendEmailStatus:"",
        isActive: true,
      };
      this.RoleTable = [];
      this.dialogAddUser = true;
      this.title = this.$t('AddUser');
      this.userform.password = this.makePassword(12);
    },
    editInfo(e) {//编辑用户信息
      this.title = this.$t('EditInfo');
      this.dialogAddUser = true;
      this.userform = e;
      // e.roleNames.forEach((item, index) => {
      //     this.RoleList.map(i => {
      //         if (item == i.name) {
      //
      //         }
      //     })
      // })
      this.getpermissionById(e.id).then((res) => {

        var arr = [];
        for (var i = 0; i < res.roleDataPermissionList.length; i++) {
          var obj = {};
          obj.id = res.roleDataPermissionList[i].roleId;
          this.RoleList.map((item) => {
            if (item.id == res.roleDataPermissionList[i].roleId) {
              obj.roles = item.dataPermissionType;
            }
          });
          if (obj.roles != "All") {
            obj.access =
                res.roleDataPermissionList[i].roleDataPermissionStringList;
          } else {
            obj.access = ["All"];
          }
          arr.push(obj);
        }
        this.RoleTable = arr;
      });
      var that = this
      // // this.userform.password=''
      // setTimeout(function () {
      //     that.userform.password=''
      //     that.pwd = false
      // },100)
    },
    async getpermissionById(data) {
      var that = this,
          result = "";
      await GetUserRoleListDatapermission(data).then(
          (res) => {
            if (res.success) {
              result = res.result;
            }
          },
          (err) => {
            that.$message.error(this.$t('failed'));
          }
      );
      return result;
    },
    //分页数据
    handleCurrentChange(val) {
      this.pagination.current = val;
      this.getUserList();
    },
    //用户列表
    async getUserList() {
      this.loading = true;
      let skipcount = (this.pagination.current - 1) * this.pagination.pageSize;
      // console.log(this.formselect.queryString)
      let data = await getUser(
          this.formselect.queryString,
          this.formselect.roleId,
          true,
          skipcount,
          this.pagination.pageSize
      );
      this.userInfoList = data.result.items;
      this.userInfoList.sort((a, b) => {
        return b.id - a.id;
      });
      this.loading = false;
      this.userInfoList.map((i) => {
        i.roleNames = i.roleNames.join(", ");
      });
      // console.log(this.userInfoList);
      this.pagination.totalPage = data.result.totalCount;
    },
    async getRoleDic(){
      let data = await getAllRoleDic();
      this.roleDic = data.result;
    },
    //换页
    async pageChange() {
      this.getUserList();
    },
    //角色列表
    async getRoleList() {
      let data = await getAllRole();
      this.RoleList = data.result.items;
      // console.log(this.RoleList)
    },

    async getcityList() {
      let data = await getCityAlls();
      this.citylist = data.result.items;
      this.getfactoryList();
    },
    async getfactoryList() {
      let data = await getFactoryAlls();
      this.factorylist = data.result.items;
      // console.log(this.factorylist);
      this.getbuildingList();
    },
    async getbuildingList() {
      let data = await GetBuildingAlls();
      this.buildinglist = data.result.items;
      this.getLabList();
    },
    async getLabList() {
      let data = await getLabAlls();
      this.lablist = data.result.items;
      // this.getDeviceAll()
      this.getOptionsinfo();
    },
    async getDeviceAll() {
      let data = await GetAllDevice();
      this.deviceList = data.result.items;
    },
    //获取权限
    getOptionsinfo(value) {
      var optionsAll = JSON.parse(sessionStorage.getItem("areaListForUser"));
      var optionsCity = JSON.parse(sessionStorage.getItem("areaListForUser"));
      var optionsFac = JSON.parse(sessionStorage.getItem("areaListForUser"));
      var optionsBuild = JSON.parse(sessionStorage.getItem("areaListForUser"));
      var optionsLab = JSON.parse(sessionStorage.getItem("areaListForUser"));
      optionsCity.map((i) => {
        delete i.children;
      });
      optionsFac.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            delete j.children;
          });
        }
      });
      optionsBuild.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            if (j.children) {
              j.children.map((k) => {
                delete k.children;
              });
            }
          });
        }
      });
      optionsLab.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            if (j.children) {
              j.children.map((k) => {
                if (k.children) {
                  k.children = k.children.filter(m => m.value != "00000000-0000-0000-0000-000000000000")
                  k.children.map((m) => {
                    delete m.children;
                  });
                }
              });
            }
          });
        }
      });
      optionsAll.map((i) => {
        if (i.children) {
          i.children.map((j) => {
            if (j.children) {
              j.children.map((k) => {
                if (k.children) {
                  k.children.map((m) => {
                    if (m.value == "00000000-0000-0000-0000-000000000000") {
                      m.label = this.$t('NonLaboratory')
                    }
                  });
                }
              });
            }
          });
        }
      });
      this.optionsCity = optionsCity;
      this.optionsFac = optionsFac;
      this.optionsBuild = optionsBuild;
      this.optionsLab = optionsLab;
      this.optionsAll = optionsAll;
    },
    async selectChange(value) {
      this.RoleList.map((item, index) => {
        if (value.id == item.id) {
          value.roles = item.dataPermissionType;
        }
      });
    },
    getTypeArr(type) {
      if (type == "Factory") {
        this.allData = this.factorylist; //id为空，取所有列表
        for (var i = 0; i < this.allData.length; i++) {
          var newData = {
            value: this.allData[i].factoryName,
            label: this.allData[i].factoryId,
            children: [],
          };
          // if (stopType != type) {
          //     //获取下级
          //     newData.children = this.getTypeArr(this.nextType(type), this.allData[i].FactoryId, stopType);
          // }
          this.allData.push(newData);
        }
      }
      return this.allData;
    },

    //取到下一个区域
    nextType(type) {
      var regionArr = [
        "Country",
        "City",
        "Factory",
        "Building",
        "Lab",
        "Device",
      ];
      var resi = 0;
      for (var i = 0; i < regionArr.length; i++) {
        resi = i;
        if (regionArr[i] == type) {
          break;
        }
      }
      if (resi == regionArr.length - 1) return -1;
      return regionArr[resi + 1];
    },
    validateEmail(email) {
      // 邮箱验证正则
      var reg = /^[A-Za-z0-9]+([_\.][A-Za-z0-9]+)*@([A-Za-z0-9\-]+\.)+[A-Za-z]{2,6}$/;
      return reg.test(email);
    },
    confirm() {
      if (!this.pwdForm.pwd) {
        this.$message.warning(this.$t('CannotBeEmpty'));
        return;
      }
      var data = {
            adminPassword: this.pwdForm.pwd,
            userId: this.userform.id,
            newPassword: this.userform.password,
          },
          that = this;
      ResetPassword(data).then((res) => {
        if (res.success) {
          that.isExtPwd = true;
          that.dialogEditPwd = false;
          that.$message.success(this.$t('SuccessfulVerification'));
          that.onSubmit();
          that.pwdForm.pwd = "";
        }
      });
    },
    onSubmit() {
      if (
          this.userform.password &&
          !this.isExtPwd &&
          this.title == this.$t('EditInfo')
      ) {
        this.dialogEditPwd = true;
        return;
      }
      if (
          !this.userform.userName ||
          !this.userform.mobilePhone ||
          !this.userform.emailAddress
      ) {
        this.$message.warning(this.$t('enterComplete') + '!');
        return;
      }
      if (!this.validateEmail(this.userform.emailAddress)) {
        this.$message.warning(this.$t('enterEmail'));
        return;
      }
      var myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!myreg.test(this.userform.mobilePhone)) {
        this.$message.warning(this.$t('refill'));
        return false;
      }
      if (this.RoleTable.length == 0) {
        this.$message.warning(this.$t('selectRole'));
        return;
      }
      if (this.RoleTable.length == 1 && this.RoleTable[0].id == "") {
        this.$message.warning(this.$t('selectRole'));
        return;
      }
      if (this.RoleTable[0].access.length == 0) {
        this.$message.warning(this.$t('allocation'));
        return;
      }
      if (this.title != this.$t('EditInfo') && (!this.userform.password)) {
        this.$message.warning(this.$t('enterComplete') + '!');
        return;
      }
      var arr = [];

      this.RoleTable.map((i) => {
        var arr1 = [],
            arr2 = [],
            arr3 = [],
            arr4 = [],
            arr5 = [];
        var obj = {};
        obj.roleId = i.id;
        obj.roles = i.roles;
        // obj.countrys = ["3fa85f64-5717-4562-b3fc-2c963f66afa6"]
        if (i.roles != "All") {
          i.access.map((j) => {
            j.forEach((k, index) => {
              switch (index) {
                case 0:
                  arr1.push(k);
                  break;
                case 1:
                  arr2.push(k);
                  break;
                case 2:
                  arr3.push(k);
                  break;
                case 3:
                  arr4.push(k);
                  break;
                case 4:
                  arr5.push(k);
                  break;
              }
            });
            obj.citys = arr1;
            obj.factorys = arr2;
            obj.buildings = arr3;
            obj.laboratory = arr4;
            obj.equipments = arr5;
          });
        }
        arr.push(obj);
      });
      var data = this.userform,
          that = this;
      data.dataPermissionlist = arr;
      // console.log(this.RoleTable,data.dataPermissionlist)
      data.dataPermissionlist.map((item) => {
        if (item.citys) {
          if (item.equipments.length > 0) {
            delete item.citys;
            delete item.factorys;
            delete item.buildings;
            delete item.laboratory;
          } else if (
              item.equipments.length == 0 &&
              item.laboratory.length > 0
          ) {
            delete item.citys;
            delete item.factorys;
            delete item.buildings;
            delete item.equipments;
          } else if (
              item.equipments.length == 0 &&
              item.laboratory.length == 0 &&
              item.buildings.length > 0
          ) {
            delete item.citys;
            delete item.factorys;
            delete item.laboratory;
            delete item.equipments;
          } else if (
              item.equipments.length == 0 &&
              item.laboratory.length == 0 &&
              item.buildings.length == 0 &&
              item.factorys.length > 0
          ) {
            delete item.citys;
            delete item.buildings;
            delete item.laboratory;
            delete item.equipments;
          } else {
            delete item.factorys;
            delete item.buildings;
            delete item.laboratory;
            delete item.equipments;
          }
          if (
              (item.roles == "Device" && !item.equipments) ||
              (item.roles == "Laboratory" && !item.laboratory) ||
              (item.roles == "Factory" && !item.factorys)
          ) {
            this.$message.warning(this.$t('NotMatch'));
            return;
          }
        }
      });
      if (this.title == this.$t('AddUser')) {
        delete data.id;
        addUser(data).then((res) => {
          if (res.success) {
            that.$message.success(this.$t('Creation'));
            that.getUserList();
          } else {
            that.$message.error(res.error.message);
          }
          that.dialogAddUser = false;
          that.isExtPwd = false;
        });
      } else {
        var data1 = {
          id: data.id,
          emailAddress: data.emailAddress,
          userName: data.userName,
          // password: that.userform.password || '',
          mobilePhone: data.mobilePhone,
          isActive: true,
          Name: data.name,
          Surname: data.name,
          languageName :data.languageName,
          sendEmailStatus:data.sendEmailStatus
        };
        UpdateUser(data1).then((res) => {
          if (res.success) {
            that.$message.success(this.$t('Update'));
          } else {
            that.$message.error(res.error.message);
          }
          that.dialogAddUser = false;
          that.isExtPwd = false;
        });
        that.updateRoleDataPermissionList(data.dataPermissionlist);
      }
    },
    //更新角色权限
    updateRoleDataPermissionList(e) {
      var data = {
            userId: this.userform.id,
            datalist: e,
          },
          that = this;
      UpdateRoleDataPermissionList(data).then((res) => {
        if (res.success) {
          that.getUserList();
        }
      });
    },
    // 增加行  楼宇
    addBuildRow() {
      var list = {
        RoleTablerowNum: this.RoleTablerowNum,
        id: "",
        roles: "",
        access: "",
      };
      this.RoleTable.push(list);
      this.RoleTablerowNum += 1;
    },
    // 删除选中行 楼宇
    delBuildRow(index, row) {
      this.RoleTable.splice(index, 1);
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
};
</script>

<style>
.el-cascader__tags .el-tag:not(.is-hit) {
  overflow: hidden;
}

#formPer .el-form-item__content {
  line-height: 35px;
  border-left: 1px solid #ebeef5;
  padding-left: 10px;
}

#formPer > .el-form-item {
  margin-bottom: 0px;
  border-bottom: 1px solid #ebeef5;
}

#formPer .noborder .el-form-item__content {
  border: 0;
}

#formPer .noborder {
  border: 0;
  margin-top: 20px;
}
</style>
